// @generated by protobuf-ts 2.11.1 with parameter generate_dependencies,ts_nocheck
// @generated from protobuf file "agency/registry/v1/registry.proto" (package "agency.registry.v1", syntax proto3)
// tslint:disable
// @ts-nocheck
import type { BinaryWriteOptions } from "@protobuf-ts/runtime";
import type { IBinaryWriter } from "@protobuf-ts/runtime";
import { WireType } from "@protobuf-ts/runtime";
import type { BinaryReadOptions } from "@protobuf-ts/runtime";
import type { IBinaryReader } from "@protobuf-ts/runtime";
import { UnknownFieldHandler } from "@protobuf-ts/runtime";
import type { PartialMessage } from "@protobuf-ts/runtime";
import { reflectionMergePartial } from "@protobuf-ts/runtime";
import { MessageType } from "@protobuf-ts/runtime";
import { NodeKind } from "../../address/v1/address";
import { Timestamp } from "../../../google/protobuf/timestamp";
import { ActorAddress } from "../../address/v1/address";
/**
 * URNRegistration registers an actor in the registry.
 *
 * @generated from protobuf message agency.registry.v1.URNRegistration
 */
export interface URNRegistration {
    /**
     * urn is the actor's universal resource name.
     *
     * @generated from protobuf field: agency.address.v1.ActorAddress urn = 1
     */
    urn?: ActorAddress;
    /**
     * pid is the Hollywood actor PID (opaque identifier).
     *
     * @generated from protobuf field: string pid = 2
     */
    pid: string;
    /**
     * registered_at is when the actor was registered.
     *
     * @generated from protobuf field: google.protobuf.Timestamp registered_at = 3
     */
    registeredAt?: Timestamp;
    /**
     * expires_at is when the registration expires (for ephemeral actors).
     *
     * @generated from protobuf field: google.protobuf.Timestamp expires_at = 4
     */
    expiresAt?: Timestamp;
    /**
     * metadata contains additional actor context.
     *
     * @generated from protobuf field: map<string, string> metadata = 5
     */
    metadata: {
        [key: string]: string;
    };
    /**
     * capabilities are advertised actor capabilities.
     *
     * @generated from protobuf field: repeated string capabilities = 6
     */
    capabilities: string[];
    /**
     * tags are categorization labels for discovery.
     *
     * @generated from protobuf field: repeated string tags = 7
     */
    tags: string[];
    /**
     * health_status indicates the actor's health.
     *
     * @generated from protobuf field: agency.registry.v1.HealthStatus health_status = 8
     */
    healthStatus: HealthStatus;
}
/**
 * URNDeregistration removes an actor from the registry.
 *
 * @generated from protobuf message agency.registry.v1.URNDeregistration
 */
export interface URNDeregistration {
    /**
     * urn is the actor's universal resource name.
     *
     * @generated from protobuf field: agency.address.v1.ActorAddress urn = 1
     */
    urn?: ActorAddress;
    /**
     * deregistered_at is when the actor was deregistered.
     *
     * @generated from protobuf field: google.protobuf.Timestamp deregistered_at = 2
     */
    deregisteredAt?: Timestamp;
    /**
     * reason explains why the actor was deregistered.
     *
     * @generated from protobuf field: string reason = 3
     */
    reason: string;
}
/**
 * URNResolution resolves a URN to an actor PID.
 *
 * @generated from protobuf message agency.registry.v1.URNResolution
 */
export interface URNResolution {
    /**
     * urn is the URN to resolve.
     *
     * @generated from protobuf field: agency.address.v1.ActorAddress urn = 1
     */
    urn?: ActorAddress;
    /**
     * pid is the resolved Hollywood actor PID.
     *
     * @generated from protobuf field: string pid = 2
     */
    pid: string;
    /**
     * registered_at is when the actor was registered.
     *
     * @generated from protobuf field: google.protobuf.Timestamp registered_at = 3
     */
    registeredAt?: Timestamp;
    /**
     * health_status indicates the actor's health.
     *
     * @generated from protobuf field: agency.registry.v1.HealthStatus health_status = 4
     */
    healthStatus: HealthStatus;
    /**
     * capabilities are the actor's advertised capabilities.
     *
     * @generated from protobuf field: repeated string capabilities = 5
     */
    capabilities: string[];
    /**
     * metadata contains additional actor context.
     *
     * @generated from protobuf field: map<string, string> metadata = 6
     */
    metadata: {
        [key: string]: string;
    };
}
/**
 * URNQueryRequest requests URNs matching criteria.
 *
 * @generated from protobuf message agency.registry.v1.URNQueryRequest
 */
export interface URNQueryRequest {
    /**
     * tenant filters by tenant (empty = all).
     *
     * @generated from protobuf field: string tenant = 1
     */
    tenant: string;
    /**
     * workspace filters by workspace (empty = all).
     *
     * @generated from protobuf field: string workspace = 2
     */
    workspace: string;
    /**
     * session filters by session (empty = all).
     *
     * @generated from protobuf field: string session = 3
     */
    session: string;
    /**
     * role filters by actor role (empty = all).
     *
     * @generated from protobuf field: string role = 4
     */
    role: string;
    /**
     * node_kind filters by node type.
     *
     * @generated from protobuf field: agency.address.v1.NodeKind node_kind = 5
     */
    nodeKind: NodeKind;
    /**
     * health_status filters by health status.
     *
     * @generated from protobuf field: agency.registry.v1.HealthStatus health_status = 6
     */
    healthStatus: HealthStatus;
    /**
     * tags filters by tags (all must match).
     *
     * @generated from protobuf field: repeated string tags = 7
     */
    tags: string[];
    /**
     * capabilities filters by capabilities (all must match).
     *
     * @generated from protobuf field: repeated string capabilities = 8
     */
    capabilities: string[];
    /**
     * limit is the maximum results to return.
     *
     * @generated from protobuf field: int32 limit = 9
     */
    limit: number;
    /**
     * offset is the pagination offset.
     *
     * @generated from protobuf field: int32 offset = 10
     */
    offset: number;
}
/**
 * URNQueryResponse returns matching URN registrations.
 *
 * @generated from protobuf message agency.registry.v1.URNQueryResponse
 */
export interface URNQueryResponse {
    /**
     * registrations are the matching URN registrations.
     *
     * @generated from protobuf field: repeated agency.registry.v1.URNRegistration registrations = 1
     */
    registrations: URNRegistration[];
    /**
     * total_count is the total matching registrations.
     *
     * @generated from protobuf field: int32 total_count = 2
     */
    totalCount: number;
    /**
     * has_more indicates if more results are available.
     *
     * @generated from protobuf field: bool has_more = 3
     */
    hasMore: boolean;
}
/**
 * ActorHeartbeat reports actor health status.
 *
 * @generated from protobuf message agency.registry.v1.ActorHeartbeat
 */
export interface ActorHeartbeat {
    /**
     * urn is the actor's universal resource name.
     *
     * @generated from protobuf field: agency.address.v1.ActorAddress urn = 1
     */
    urn?: ActorAddress;
    /**
     * health_status is the current health status.
     *
     * @generated from protobuf field: agency.registry.v1.HealthStatus health_status = 2
     */
    healthStatus: HealthStatus;
    /**
     * heartbeat_at is when the heartbeat occurred.
     *
     * @generated from protobuf field: google.protobuf.Timestamp heartbeat_at = 3
     */
    heartbeatAt?: Timestamp;
    /**
     * metrics contains health metrics.
     *
     * @generated from protobuf field: map<string, double> metrics = 4
     */
    metrics: {
        [key: string]: number;
    };
    /**
     * message provides additional health context.
     *
     * @generated from protobuf field: string message = 5
     */
    message: string;
}
/**
 * ActorDiscoveryRequest requests actors matching criteria for discovery.
 *
 * @generated from protobuf message agency.registry.v1.ActorDiscoveryRequest
 */
export interface ActorDiscoveryRequest {
    /**
     * tenant is the tenant context.
     *
     * @generated from protobuf field: string tenant = 1
     */
    tenant: string;
    /**
     * workspace is the workspace context.
     *
     * @generated from protobuf field: string workspace = 2
     */
    workspace: string;
    /**
     * role_prefix matches actors by role prefix.
     *
     * @generated from protobuf field: string role_prefix = 3
     */
    rolePrefix: string;
    /**
     * required_capabilities are capabilities that must be present.
     *
     * @generated from protobuf field: repeated string required_capabilities = 4
     */
    requiredCapabilities: string[];
    /**
     * exclude_unhealthy filters out unhealthy actors.
     *
     * @generated from protobuf field: bool exclude_unhealthy = 5
     */
    excludeUnhealthy: boolean;
}
/**
 * ActorDiscoveryResponse returns discovered actors.
 *
 * @generated from protobuf message agency.registry.v1.ActorDiscoveryResponse
 */
export interface ActorDiscoveryResponse {
    /**
     * actors are the discovered actor registrations.
     *
     * @generated from protobuf field: repeated agency.registry.v1.URNRegistration actors = 1
     */
    actors: URNRegistration[];
    /**
     * discovered_at is when the discovery occurred.
     *
     * @generated from protobuf field: google.protobuf.Timestamp discovered_at = 2
     */
    discoveredAt?: Timestamp;
}
/**
 * HealthStatus represents actor health.
 *
 * @generated from protobuf enum agency.registry.v1.HealthStatus
 */
export enum HealthStatus {
    /**
     * UNSPECIFIED is the zero value and should not be used.
     *
     * @generated from protobuf enum value: HEALTH_STATUS_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * STARTING indicates the actor is initializing.
     *
     * @generated from protobuf enum value: HEALTH_STATUS_STARTING = 1;
     */
    STARTING = 1,
    /**
     * HEALTHY indicates the actor is operational.
     *
     * @generated from protobuf enum value: HEALTH_STATUS_HEALTHY = 2;
     */
    HEALTHY = 2,
    /**
     * DEGRADED indicates the actor is operational but with issues.
     *
     * @generated from protobuf enum value: HEALTH_STATUS_DEGRADED = 3;
     */
    DEGRADED = 3,
    /**
     * UNHEALTHY indicates the actor is not operational.
     *
     * @generated from protobuf enum value: HEALTH_STATUS_UNHEALTHY = 4;
     */
    UNHEALTHY = 4,
    /**
     * DRAINING indicates the actor is shutting down gracefully.
     *
     * @generated from protobuf enum value: HEALTH_STATUS_DRAINING = 5;
     */
    DRAINING = 5,
    /**
     * STOPPED indicates the actor has terminated.
     *
     * @generated from protobuf enum value: HEALTH_STATUS_STOPPED = 6;
     */
    STOPPED = 6
}
// @generated message type with reflection information, may provide speed optimized methods
class URNRegistration$Type extends MessageType<URNRegistration> {
    constructor() {
        super("agency.registry.v1.URNRegistration", [
            { no: 1, name: "urn", kind: "message", T: () => ActorAddress, options: { "buf.validate.field": { required: true } } },
            { no: 2, name: "pid", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "256" } } } },
            { no: 3, name: "registered_at", kind: "message", T: () => Timestamp, options: { "buf.validate.field": { required: true } } },
            { no: 4, name: "expires_at", kind: "message", T: () => Timestamp },
            { no: 5, name: "metadata", kind: "map", K: 9 /*ScalarType.STRING*/, V: { kind: "scalar", T: 9 /*ScalarType.STRING*/ }, options: { "buf.validate.field": { map: { maxPairs: "50", keys: { string: { minLen: "1", maxLen: "128" } }, values: { string: { maxLen: "2048" } } } } } },
            { no: 6, name: "capabilities", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { repeated: { maxItems: "50", items: { string: { minLen: "1", maxLen: "128", pattern: "^[a-z0-9][a-z0-9_-]*[a-z0-9]$" } } } } } },
            { no: 7, name: "tags", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { repeated: { maxItems: "20", items: { string: { minLen: "1", maxLen: "64", pattern: "^[a-z0-9][a-z0-9_-]*[a-z0-9]$" } } } } } },
            { no: 8, name: "health_status", kind: "enum", T: () => ["agency.registry.v1.HealthStatus", HealthStatus, "HEALTH_STATUS_"], options: { "buf.validate.field": { enum: { definedOnly: true, notIn: [0] } } } }
        ]);
    }
    create(value?: PartialMessage<URNRegistration>): URNRegistration {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.pid = "";
        message.metadata = {};
        message.capabilities = [];
        message.tags = [];
        message.healthStatus = 0;
        if (value !== undefined)
            reflectionMergePartial<URNRegistration>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: URNRegistration): URNRegistration {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* agency.address.v1.ActorAddress urn */ 1:
                    message.urn = ActorAddress.internalBinaryRead(reader, reader.uint32(), options, message.urn);
                    break;
                case /* string pid */ 2:
                    message.pid = reader.string();
                    break;
                case /* google.protobuf.Timestamp registered_at */ 3:
                    message.registeredAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.registeredAt);
                    break;
                case /* google.protobuf.Timestamp expires_at */ 4:
                    message.expiresAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.expiresAt);
                    break;
                case /* map<string, string> metadata */ 5:
                    this.binaryReadMap5(message.metadata, reader, options);
                    break;
                case /* repeated string capabilities */ 6:
                    message.capabilities.push(reader.string());
                    break;
                case /* repeated string tags */ 7:
                    message.tags.push(reader.string());
                    break;
                case /* agency.registry.v1.HealthStatus health_status */ 8:
                    message.healthStatus = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    private binaryReadMap5(map: URNRegistration["metadata"], reader: IBinaryReader, options: BinaryReadOptions): void {
        let len = reader.uint32(), end = reader.pos + len, key: keyof URNRegistration["metadata"] | undefined, val: URNRegistration["metadata"][any] | undefined;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case 1:
                    key = reader.string();
                    break;
                case 2:
                    val = reader.string();
                    break;
                default: throw new globalThis.Error("unknown map entry field for agency.registry.v1.URNRegistration.metadata");
            }
        }
        map[key ?? ""] = val ?? "";
    }
    internalBinaryWrite(message: URNRegistration, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* agency.address.v1.ActorAddress urn = 1; */
        if (message.urn)
            ActorAddress.internalBinaryWrite(message.urn, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string pid = 2; */
        if (message.pid !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.pid);
        /* google.protobuf.Timestamp registered_at = 3; */
        if (message.registeredAt)
            Timestamp.internalBinaryWrite(message.registeredAt, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp expires_at = 4; */
        if (message.expiresAt)
            Timestamp.internalBinaryWrite(message.expiresAt, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* map<string, string> metadata = 5; */
        for (let k of globalThis.Object.keys(message.metadata))
            writer.tag(5, WireType.LengthDelimited).fork().tag(1, WireType.LengthDelimited).string(k).tag(2, WireType.LengthDelimited).string(message.metadata[k]).join();
        /* repeated string capabilities = 6; */
        for (let i = 0; i < message.capabilities.length; i++)
            writer.tag(6, WireType.LengthDelimited).string(message.capabilities[i]);
        /* repeated string tags = 7; */
        for (let i = 0; i < message.tags.length; i++)
            writer.tag(7, WireType.LengthDelimited).string(message.tags[i]);
        /* agency.registry.v1.HealthStatus health_status = 8; */
        if (message.healthStatus !== 0)
            writer.tag(8, WireType.Varint).int32(message.healthStatus);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message agency.registry.v1.URNRegistration
 */
export const URNRegistration = new URNRegistration$Type();
// @generated message type with reflection information, may provide speed optimized methods
class URNDeregistration$Type extends MessageType<URNDeregistration> {
    constructor() {
        super("agency.registry.v1.URNDeregistration", [
            { no: 1, name: "urn", kind: "message", T: () => ActorAddress, options: { "buf.validate.field": { required: true } } },
            { no: 2, name: "deregistered_at", kind: "message", T: () => Timestamp, options: { "buf.validate.field": { required: true } } },
            { no: 3, name: "reason", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { maxLen: "1024" } } } }
        ]);
    }
    create(value?: PartialMessage<URNDeregistration>): URNDeregistration {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.reason = "";
        if (value !== undefined)
            reflectionMergePartial<URNDeregistration>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: URNDeregistration): URNDeregistration {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* agency.address.v1.ActorAddress urn */ 1:
                    message.urn = ActorAddress.internalBinaryRead(reader, reader.uint32(), options, message.urn);
                    break;
                case /* google.protobuf.Timestamp deregistered_at */ 2:
                    message.deregisteredAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.deregisteredAt);
                    break;
                case /* string reason */ 3:
                    message.reason = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: URNDeregistration, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* agency.address.v1.ActorAddress urn = 1; */
        if (message.urn)
            ActorAddress.internalBinaryWrite(message.urn, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp deregistered_at = 2; */
        if (message.deregisteredAt)
            Timestamp.internalBinaryWrite(message.deregisteredAt, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* string reason = 3; */
        if (message.reason !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.reason);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message agency.registry.v1.URNDeregistration
 */
export const URNDeregistration = new URNDeregistration$Type();
// @generated message type with reflection information, may provide speed optimized methods
class URNResolution$Type extends MessageType<URNResolution> {
    constructor() {
        super("agency.registry.v1.URNResolution", [
            { no: 1, name: "urn", kind: "message", T: () => ActorAddress, options: { "buf.validate.field": { required: true } } },
            { no: 2, name: "pid", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "256" } } } },
            { no: 3, name: "registered_at", kind: "message", T: () => Timestamp, options: { "buf.validate.field": { required: true } } },
            { no: 4, name: "health_status", kind: "enum", T: () => ["agency.registry.v1.HealthStatus", HealthStatus, "HEALTH_STATUS_"], options: { "buf.validate.field": { enum: { definedOnly: true, notIn: [0] } } } },
            { no: 5, name: "capabilities", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { repeated: { maxItems: "50" } } } },
            { no: 6, name: "metadata", kind: "map", K: 9 /*ScalarType.STRING*/, V: { kind: "scalar", T: 9 /*ScalarType.STRING*/ }, options: { "buf.validate.field": { map: { maxPairs: "50", keys: { string: { minLen: "1", maxLen: "128" } }, values: { string: { maxLen: "2048" } } } } } }
        ]);
    }
    create(value?: PartialMessage<URNResolution>): URNResolution {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.pid = "";
        message.healthStatus = 0;
        message.capabilities = [];
        message.metadata = {};
        if (value !== undefined)
            reflectionMergePartial<URNResolution>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: URNResolution): URNResolution {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* agency.address.v1.ActorAddress urn */ 1:
                    message.urn = ActorAddress.internalBinaryRead(reader, reader.uint32(), options, message.urn);
                    break;
                case /* string pid */ 2:
                    message.pid = reader.string();
                    break;
                case /* google.protobuf.Timestamp registered_at */ 3:
                    message.registeredAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.registeredAt);
                    break;
                case /* agency.registry.v1.HealthStatus health_status */ 4:
                    message.healthStatus = reader.int32();
                    break;
                case /* repeated string capabilities */ 5:
                    message.capabilities.push(reader.string());
                    break;
                case /* map<string, string> metadata */ 6:
                    this.binaryReadMap6(message.metadata, reader, options);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    private binaryReadMap6(map: URNResolution["metadata"], reader: IBinaryReader, options: BinaryReadOptions): void {
        let len = reader.uint32(), end = reader.pos + len, key: keyof URNResolution["metadata"] | undefined, val: URNResolution["metadata"][any] | undefined;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case 1:
                    key = reader.string();
                    break;
                case 2:
                    val = reader.string();
                    break;
                default: throw new globalThis.Error("unknown map entry field for agency.registry.v1.URNResolution.metadata");
            }
        }
        map[key ?? ""] = val ?? "";
    }
    internalBinaryWrite(message: URNResolution, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* agency.address.v1.ActorAddress urn = 1; */
        if (message.urn)
            ActorAddress.internalBinaryWrite(message.urn, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string pid = 2; */
        if (message.pid !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.pid);
        /* google.protobuf.Timestamp registered_at = 3; */
        if (message.registeredAt)
            Timestamp.internalBinaryWrite(message.registeredAt, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* agency.registry.v1.HealthStatus health_status = 4; */
        if (message.healthStatus !== 0)
            writer.tag(4, WireType.Varint).int32(message.healthStatus);
        /* repeated string capabilities = 5; */
        for (let i = 0; i < message.capabilities.length; i++)
            writer.tag(5, WireType.LengthDelimited).string(message.capabilities[i]);
        /* map<string, string> metadata = 6; */
        for (let k of globalThis.Object.keys(message.metadata))
            writer.tag(6, WireType.LengthDelimited).fork().tag(1, WireType.LengthDelimited).string(k).tag(2, WireType.LengthDelimited).string(message.metadata[k]).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message agency.registry.v1.URNResolution
 */
export const URNResolution = new URNResolution$Type();
// @generated message type with reflection information, may provide speed optimized methods
class URNQueryRequest$Type extends MessageType<URNQueryRequest> {
    constructor() {
        super("agency.registry.v1.URNQueryRequest", [
            { no: 1, name: "tenant", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { maxLen: "64", pattern: "^([a-z0-9][a-z0-9-]*[a-z0-9])?$" } } } },
            { no: 2, name: "workspace", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { maxLen: "64", pattern: "^([a-z0-9][a-z0-9-]*[a-z0-9])?$" } } } },
            { no: 3, name: "session", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { maxLen: "128", pattern: "^([a-z0-9][a-z0-9-]*[a-z0-9])?$" } } } },
            { no: 4, name: "role", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { maxLen: "128", pattern: "^([a-z0-9][a-z0-9._-]*[a-z0-9])?$" } } } },
            { no: 5, name: "node_kind", kind: "enum", T: () => ["agency.address.v1.NodeKind", NodeKind, "NODE_KIND_"] },
            { no: 6, name: "health_status", kind: "enum", T: () => ["agency.registry.v1.HealthStatus", HealthStatus, "HEALTH_STATUS_"] },
            { no: 7, name: "tags", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { repeated: { maxItems: "20", items: { string: { minLen: "1", maxLen: "64" } } } } } },
            { no: 8, name: "capabilities", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { repeated: { maxItems: "50", items: { string: { minLen: "1", maxLen: "128" } } } } } },
            { no: 9, name: "limit", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "buf.validate.field": { int32: { lte: 1000, gte: 1 } } } },
            { no: 10, name: "offset", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "buf.validate.field": { int32: { gte: 0 } } } }
        ]);
    }
    create(value?: PartialMessage<URNQueryRequest>): URNQueryRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.tenant = "";
        message.workspace = "";
        message.session = "";
        message.role = "";
        message.nodeKind = 0;
        message.healthStatus = 0;
        message.tags = [];
        message.capabilities = [];
        message.limit = 0;
        message.offset = 0;
        if (value !== undefined)
            reflectionMergePartial<URNQueryRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: URNQueryRequest): URNQueryRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string tenant */ 1:
                    message.tenant = reader.string();
                    break;
                case /* string workspace */ 2:
                    message.workspace = reader.string();
                    break;
                case /* string session */ 3:
                    message.session = reader.string();
                    break;
                case /* string role */ 4:
                    message.role = reader.string();
                    break;
                case /* agency.address.v1.NodeKind node_kind */ 5:
                    message.nodeKind = reader.int32();
                    break;
                case /* agency.registry.v1.HealthStatus health_status */ 6:
                    message.healthStatus = reader.int32();
                    break;
                case /* repeated string tags */ 7:
                    message.tags.push(reader.string());
                    break;
                case /* repeated string capabilities */ 8:
                    message.capabilities.push(reader.string());
                    break;
                case /* int32 limit */ 9:
                    message.limit = reader.int32();
                    break;
                case /* int32 offset */ 10:
                    message.offset = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: URNQueryRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string tenant = 1; */
        if (message.tenant !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.tenant);
        /* string workspace = 2; */
        if (message.workspace !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.workspace);
        /* string session = 3; */
        if (message.session !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.session);
        /* string role = 4; */
        if (message.role !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.role);
        /* agency.address.v1.NodeKind node_kind = 5; */
        if (message.nodeKind !== 0)
            writer.tag(5, WireType.Varint).int32(message.nodeKind);
        /* agency.registry.v1.HealthStatus health_status = 6; */
        if (message.healthStatus !== 0)
            writer.tag(6, WireType.Varint).int32(message.healthStatus);
        /* repeated string tags = 7; */
        for (let i = 0; i < message.tags.length; i++)
            writer.tag(7, WireType.LengthDelimited).string(message.tags[i]);
        /* repeated string capabilities = 8; */
        for (let i = 0; i < message.capabilities.length; i++)
            writer.tag(8, WireType.LengthDelimited).string(message.capabilities[i]);
        /* int32 limit = 9; */
        if (message.limit !== 0)
            writer.tag(9, WireType.Varint).int32(message.limit);
        /* int32 offset = 10; */
        if (message.offset !== 0)
            writer.tag(10, WireType.Varint).int32(message.offset);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message agency.registry.v1.URNQueryRequest
 */
export const URNQueryRequest = new URNQueryRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class URNQueryResponse$Type extends MessageType<URNQueryResponse> {
    constructor() {
        super("agency.registry.v1.URNQueryResponse", [
            { no: 1, name: "registrations", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => URNRegistration, options: { "buf.validate.field": { repeated: { maxItems: "1000" } } } },
            { no: 2, name: "total_count", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "buf.validate.field": { int32: { gte: 0 } } } },
            { no: 3, name: "has_more", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<URNQueryResponse>): URNQueryResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.registrations = [];
        message.totalCount = 0;
        message.hasMore = false;
        if (value !== undefined)
            reflectionMergePartial<URNQueryResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: URNQueryResponse): URNQueryResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated agency.registry.v1.URNRegistration registrations */ 1:
                    message.registrations.push(URNRegistration.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* int32 total_count */ 2:
                    message.totalCount = reader.int32();
                    break;
                case /* bool has_more */ 3:
                    message.hasMore = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: URNQueryResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated agency.registry.v1.URNRegistration registrations = 1; */
        for (let i = 0; i < message.registrations.length; i++)
            URNRegistration.internalBinaryWrite(message.registrations[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* int32 total_count = 2; */
        if (message.totalCount !== 0)
            writer.tag(2, WireType.Varint).int32(message.totalCount);
        /* bool has_more = 3; */
        if (message.hasMore !== false)
            writer.tag(3, WireType.Varint).bool(message.hasMore);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message agency.registry.v1.URNQueryResponse
 */
export const URNQueryResponse = new URNQueryResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ActorHeartbeat$Type extends MessageType<ActorHeartbeat> {
    constructor() {
        super("agency.registry.v1.ActorHeartbeat", [
            { no: 1, name: "urn", kind: "message", T: () => ActorAddress, options: { "buf.validate.field": { required: true } } },
            { no: 2, name: "health_status", kind: "enum", T: () => ["agency.registry.v1.HealthStatus", HealthStatus, "HEALTH_STATUS_"], options: { "buf.validate.field": { enum: { definedOnly: true, notIn: [0] } } } },
            { no: 3, name: "heartbeat_at", kind: "message", T: () => Timestamp, options: { "buf.validate.field": { required: true } } },
            { no: 4, name: "metrics", kind: "map", K: 9 /*ScalarType.STRING*/, V: { kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ }, options: { "buf.validate.field": { map: { maxPairs: "50", keys: { string: { minLen: "1", maxLen: "128" } } } } } },
            { no: 5, name: "message", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { maxLen: "1024" } } } }
        ]);
    }
    create(value?: PartialMessage<ActorHeartbeat>): ActorHeartbeat {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.healthStatus = 0;
        message.metrics = {};
        message.message = "";
        if (value !== undefined)
            reflectionMergePartial<ActorHeartbeat>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ActorHeartbeat): ActorHeartbeat {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* agency.address.v1.ActorAddress urn */ 1:
                    message.urn = ActorAddress.internalBinaryRead(reader, reader.uint32(), options, message.urn);
                    break;
                case /* agency.registry.v1.HealthStatus health_status */ 2:
                    message.healthStatus = reader.int32();
                    break;
                case /* google.protobuf.Timestamp heartbeat_at */ 3:
                    message.heartbeatAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.heartbeatAt);
                    break;
                case /* map<string, double> metrics */ 4:
                    this.binaryReadMap4(message.metrics, reader, options);
                    break;
                case /* string message */ 5:
                    message.message = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    private binaryReadMap4(map: ActorHeartbeat["metrics"], reader: IBinaryReader, options: BinaryReadOptions): void {
        let len = reader.uint32(), end = reader.pos + len, key: keyof ActorHeartbeat["metrics"] | undefined, val: ActorHeartbeat["metrics"][any] | undefined;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case 1:
                    key = reader.string();
                    break;
                case 2:
                    val = reader.double();
                    break;
                default: throw new globalThis.Error("unknown map entry field for agency.registry.v1.ActorHeartbeat.metrics");
            }
        }
        map[key ?? ""] = val ?? 0;
    }
    internalBinaryWrite(message: ActorHeartbeat, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* agency.address.v1.ActorAddress urn = 1; */
        if (message.urn)
            ActorAddress.internalBinaryWrite(message.urn, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* agency.registry.v1.HealthStatus health_status = 2; */
        if (message.healthStatus !== 0)
            writer.tag(2, WireType.Varint).int32(message.healthStatus);
        /* google.protobuf.Timestamp heartbeat_at = 3; */
        if (message.heartbeatAt)
            Timestamp.internalBinaryWrite(message.heartbeatAt, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* map<string, double> metrics = 4; */
        for (let k of globalThis.Object.keys(message.metrics))
            writer.tag(4, WireType.LengthDelimited).fork().tag(1, WireType.LengthDelimited).string(k).tag(2, WireType.Bit64).double(message.metrics[k]).join();
        /* string message = 5; */
        if (message.message !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.message);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message agency.registry.v1.ActorHeartbeat
 */
export const ActorHeartbeat = new ActorHeartbeat$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ActorDiscoveryRequest$Type extends MessageType<ActorDiscoveryRequest> {
    constructor() {
        super("agency.registry.v1.ActorDiscoveryRequest", [
            { no: 1, name: "tenant", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "64", pattern: "^[a-z0-9][a-z0-9-]*[a-z0-9]$" } } } },
            { no: 2, name: "workspace", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "64", pattern: "^[a-z0-9][a-z0-9-]*[a-z0-9]$" } } } },
            { no: 3, name: "role_prefix", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { maxLen: "128", pattern: "^[a-z0-9][a-z0-9._-]*$" } } } },
            { no: 4, name: "required_capabilities", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { repeated: { maxItems: "50", items: { string: { minLen: "1", maxLen: "128" } } } } } },
            { no: 5, name: "exclude_unhealthy", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<ActorDiscoveryRequest>): ActorDiscoveryRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.tenant = "";
        message.workspace = "";
        message.rolePrefix = "";
        message.requiredCapabilities = [];
        message.excludeUnhealthy = false;
        if (value !== undefined)
            reflectionMergePartial<ActorDiscoveryRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ActorDiscoveryRequest): ActorDiscoveryRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string tenant */ 1:
                    message.tenant = reader.string();
                    break;
                case /* string workspace */ 2:
                    message.workspace = reader.string();
                    break;
                case /* string role_prefix */ 3:
                    message.rolePrefix = reader.string();
                    break;
                case /* repeated string required_capabilities */ 4:
                    message.requiredCapabilities.push(reader.string());
                    break;
                case /* bool exclude_unhealthy */ 5:
                    message.excludeUnhealthy = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ActorDiscoveryRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string tenant = 1; */
        if (message.tenant !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.tenant);
        /* string workspace = 2; */
        if (message.workspace !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.workspace);
        /* string role_prefix = 3; */
        if (message.rolePrefix !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.rolePrefix);
        /* repeated string required_capabilities = 4; */
        for (let i = 0; i < message.requiredCapabilities.length; i++)
            writer.tag(4, WireType.LengthDelimited).string(message.requiredCapabilities[i]);
        /* bool exclude_unhealthy = 5; */
        if (message.excludeUnhealthy !== false)
            writer.tag(5, WireType.Varint).bool(message.excludeUnhealthy);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message agency.registry.v1.ActorDiscoveryRequest
 */
export const ActorDiscoveryRequest = new ActorDiscoveryRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ActorDiscoveryResponse$Type extends MessageType<ActorDiscoveryResponse> {
    constructor() {
        super("agency.registry.v1.ActorDiscoveryResponse", [
            { no: 1, name: "actors", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => URNRegistration, options: { "buf.validate.field": { repeated: { maxItems: "1000" } } } },
            { no: 2, name: "discovered_at", kind: "message", T: () => Timestamp, options: { "buf.validate.field": { required: true } } }
        ]);
    }
    create(value?: PartialMessage<ActorDiscoveryResponse>): ActorDiscoveryResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.actors = [];
        if (value !== undefined)
            reflectionMergePartial<ActorDiscoveryResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ActorDiscoveryResponse): ActorDiscoveryResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated agency.registry.v1.URNRegistration actors */ 1:
                    message.actors.push(URNRegistration.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* google.protobuf.Timestamp discovered_at */ 2:
                    message.discoveredAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.discoveredAt);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ActorDiscoveryResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated agency.registry.v1.URNRegistration actors = 1; */
        for (let i = 0; i < message.actors.length; i++)
            URNRegistration.internalBinaryWrite(message.actors[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp discovered_at = 2; */
        if (message.discoveredAt)
            Timestamp.internalBinaryWrite(message.discoveredAt, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message agency.registry.v1.ActorDiscoveryResponse
 */
export const ActorDiscoveryResponse = new ActorDiscoveryResponse$Type();
